import { AxiosError, AxiosInstance } from "axios";
import { refreshAccessToken } from "../helpers/refresh-token";
import { RequestError } from "../types";
import toast from "react-hot-toast";
import { getFieldErrorMessage } from "../helpers/error";
import { appSession } from "../../shared/lib/storage";

export function responseErrorHandlerBuilder(instance: AxiosInstance) {
  return async (err: any) => {
    const originalRequest = err.config;

    if (
      (err?.status === 401 ||
        err.response?.data?.errors?.[0]?.msg.includes("Signature has expired") ||
        err.response?.data.python_exc?.includes("Signature has expired")) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const response = await refreshAccessToken();
        const result = response.data.result;
        instance.defaults.headers.common["Authorization"] = "Bearer " + result.access_token;
        return instance(originalRequest);
      } catch (err) {
        appSession.removeItem();
        window.location.reload();
      }
    }

    if (err.response?.data.errors?.[0]?.msg.includes("Wrong refresh token")) {
      appSession.removeItem();
      window.location.reload();
    }

    if (err instanceof AxiosError) {
      if (err.response?.status === 403) {
        return Promise.reject(err);
      }

      if (err.response?.status === 401) {
        if (!originalRequest._retry) {
          originalRequest._retry = true;
          try {
            const response = await refreshAccessToken();
            const result = response.data.result;
            instance.defaults.headers.common["Authorization"] = "Bearer " + result.access_token;

            return instance(originalRequest);
          } catch (err) {
            appSession.removeItem();
            window.location.reload();
          }
        } else {
          appSession.removeItem();
          window.location.reload();
        }
      }

      const error = err as AxiosError<RequestError>;

      if (error.response?.data.type === "logic") {
        return Promise.reject(err);
      }

      if (error.response?.data.type === "field" && error.response?.data.service === "gateway") {
        toast.error(getFieldErrorMessage(error)!);
      } else if (error.response?.data.service === "gateway.auth" || error.response?.data.type !== "field") {
        toast.error(getFieldErrorMessage(error)!);
      } else {
        toast.error(getFieldErrorMessage(error)!);
      }
    } else if (err instanceof Error) {
      toast.error("Unexpected error");
    }

    return Promise.reject(err);
  };
}
